export default class BrowserWarning {
  constructor (options) {
    this.element = options.element

    // Add class if IE10 or lower
    if (document.documentMode <= 10) {
      document.documentElement.className += ' old-ie'
    }
  }
}



// WEBPACK FOOTER //
// ./components/browser-warning/index.js